import { Fragment, useRef, useState } from 'react'
import { Dialog, Transition } from '@headlessui/react'
import { ExclamationTriangleIcon } from '@heroicons/react/24/solid'
import { useAppContext, SET_INFORMATION_ALERT, SET_ERROR_ALERT, SET_LOADING, REFRESH_DATA } from '../../Providers/AppProvider';
//import { useDochazkaContext, UPDATE_ZAPIS_DOCHAZKY } from '../../Providers/DochazkaProvider';
import { TrashIcon } from '@heroicons/react/24/solid'
import { Tooltip } from 'react-tooltip';

import axios from 'axios';
import { Config } from "../../Config";

export default function OdstraneniRezervace(props) {
  //const { dispatchDoch } = useDochazkaContext()
  const { dispatch, state:{selectedRole} } = useAppContext()
  const [open, setOpen] = useState(false)

  const cancelButtonRef = useRef(null)

  function DeleteRez() {
    dispatch({ type: SET_LOADING, payload: true })
    axios.post(`${Config.ServerURL}/api/Vozidla/OdstraneniRezervaceVozidla/${props.idRezervace}/${selectedRole}`, undefined, {
      withCredentials: true
    })
      .then((res) => {
        setOpen(false)
        if (res.data.message) {
          dispatch({ type: SET_INFORMATION_ALERT, payload: res.data.message })
        }
        dispatch({ type: REFRESH_DATA })
        dispatch({ type: SET_LOADING, payload: false })
      })
      .catch(err => {
        dispatch({ type: SET_ERROR_ALERT, payload: err.response.data.message })
        dispatch({ type: SET_LOADING, payload: false })
      })
  }


  return (
    <>
      <Transition.Root show={open} as={Fragment}>
        <Dialog as="div" className="relative z-20" initialFocus={cancelButtonRef} onClose={setOpen}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="dialog-transition" />
          </Transition.Child>

          <div className="fixed inset-0 z-30 overflow-y-auto">
            <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <Dialog.Panel className="dialog-dotaz-ramecek">
                  <div className="dialog-dotaz-obsah">
                    <div className="sm:flex sm:items-start">
                      <div className="dialog-dotaz-ikona-pozadi-cervenykruh">
                        <ExclamationTriangleIcon className="dialog-dotaz-ikona-cervena" aria-hidden="true" />
                      </div>
                      <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                        <Dialog.Title as="h3" className="dialog-dotaz-nadpis-cerveny">
                          Odebrání záznamu rezervace: <br /> 
                          {props.zamestnanec} <br /> 
                          {props.nazev} <br />
                          {props.datum}
                        </Dialog.Title>
                        <div className="mt-2">
                          <p className="dialog-dotaz-otazka">
                            Opravdu chcete odstranit tuto rezervaci?
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="dialog-dotaz-zapati-pozadi">
                    <button type="button" className="dialog-tlacitko-dotaz-akce"
                      onClick={() => DeleteRez()}>Odstranit</button>
                    <button
                      type="button"
                      className="dialog-tlacitko-dotaz-zrusit"
                      onClick={() => setOpen(false)}
                      ref={cancelButtonRef}
                    >
                      Zrušit
                    </button>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition.Root>
      <div onClick={() => setOpen(true)} className="dialog-edit-ikona-odstraneni"
        data-tooltip-id="odstraneni-rezvozidla-tooltip" 
        data-tooltip-content="Odstranění rezervace vozidla" data-tooltip-delay-show={Config.ToolTipAutoRefreshTime1} data-tooltip-variant="info" >
        <span className="sr-only">Odstranit</span>
        <TrashIcon className='w-4 h-4' aria-hidden="true" />
        <Tooltip id="odstraneni-rezvozidla-tooltip" />
      </div>
    </>
  )
}
